/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FirmwareRequestDto } from '../../models/firmware-request-dto';
import { FirmwareResponseDto } from '../../models/firmware-response-dto';

export interface ReceiveFirmwareMetadata$Params {
  vendor: string;
      body?: FirmwareRequestDto
}

export function receiveFirmwareMetadata(http: HttpClient, rootUrl: string, params: ReceiveFirmwareMetadata$Params, context?: HttpContext): Observable<StrictHttpResponse<FirmwareResponseDto>> {
  const rb = new RequestBuilder(rootUrl, receiveFirmwareMetadata.PATH, 'post');
  if (params) {
    rb.path('vendor', params.vendor, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FirmwareResponseDto>;
    })
  );
}

receiveFirmwareMetadata.PATH = '/api/{vendor}/router/firmware';
